<template>
    <div class="content-services-layout">
        <div v-for="(detailItem, itemIndex) in detailItemList" :key="itemIndex" class="content-services-grid-container">
            <div class="content-services-info-cointainer">
                <div class="content-services-info">
                    <div v-if="isCN" class="content-services-info-subtitle">{{ $t(detailItem.subtitle) }}</div>
                    <div class="content-services-info-title">{{ $t(detailItem.title) }}</div>
                    <div class="content-services-info-des">
                        <div v-for="(item, index) in detailItem.list" :key="index">
                            <CommonComponentsTextWithCheckIcon dark>
                                <div class="content-services-info-des-item">
                                    {{ $t(item) }}
                                </div>
                            </CommonComponentsTextWithCheckIcon>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-services-media-container">
                <!-- 视频设置静音以及循环播放 -->
                <CommonComponentsVideoPlayer
                    :id="`content-services-media-video-${itemIndex}`"
                    class="content-services-media-video"
                    :sources="[
                        {
                            src: detailItem.mediaPath,
                            type: 'video/mp4',
                        },
                    ]"
                    poster=""
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { reactive } from 'vue';
    import { useI18n } from 'vue-i18n';
    import { gsap } from 'gsap';
    import { ScrollTrigger } from 'gsap/all';
    import blankVideo1 from '@assets/Video/support/DPC/1.mp4';
    import blankVideo2 from '@assets/Video/support/DPC/2.mp4';
    import blankVideo3 from '@assets/Video/support/DPC/3.mp4';
    import blankVideo4 from '@assets/Video/support/DPC/4.mp4';
    import blankVideo5 from '@assets/Video/support/DPC/5.mp4';

    import videoPosterPath1 from '@assets/Video/support/DPC/1.png';
    import videoPosterPath2 from '@assets/Video/support/DPC/2.jpg';
    import videoPosterPath3 from '@assets/Video/support/DPC/3.png';
    import videoPosterPath4 from '@assets/Video/support/DPC/4.jpg';
    import videoPosterPath5 from '@assets/Video/support/DPC/5.jpg';

    import { addToVideoElmt, addLeftEnter, addRightEnter } from '~~/composables/useScrollTrigger';
    import { matchMobile } from '~~/composables/useMatchRules.ts';
    const { t } = useI18n();

    const isCN = ifCNLocale();

    gsap.registerPlugin(ScrollTrigger);

    const detailItemList = reactive<
        Array<{
            mediaPath: string;
            importposter: string;
            title: string;
            subtitle: string;
            list: Array<string>;
        }>
    >([
        {
            mediaPath: blankVideo1,
            importposter: videoPosterPath1,
            title: 'global_support_contentservices_info_title_0',
            subtitle: 'global_support_contentservices_info_subtitle_0',
            list: ['global_support_contentservices_info_text_00', 'global_support_contentservices_info_text_01'],
        },
        {
            mediaPath: blankVideo2,
            importposter: videoPosterPath2,

            title: 'global_support_contentservices_info_title_1',
            subtitle: 'global_support_contentservices_info_subtitle_1',
            list: ['global_support_contentservices_info_text_10', 'global_support_contentservices_info_text_11'],
        },
        {
            mediaPath: blankVideo3,
            importposter: videoPosterPath3,

            title: 'global_support_contentservices_info_title_2',
            subtitle: 'global_support_contentservices_info_subtitle_2',
            list: [
                'global_support_contentservices_info_text_20',
                'global_support_contentservices_info_text_21',
                'global_support_contentservices_info_text_22',
                'global_support_contentservices_info_text_23',
            ],
        },
        {
            mediaPath: blankVideo4,
            importposter: videoPosterPath4,

            title: 'global_support_contentservices_info_title_3',
            subtitle: 'global_support_contentservices_info_subtitle_3',
            list: [
                'global_support_contentservices_info_text_30',
                'global_support_contentservices_info_text_31',
                'global_support_contentservices_info_text_32',
            ],
        },
        {
            mediaPath: blankVideo5,
            importposter: videoPosterPath5,

            title: 'global_support_contentservices_info_title_4',
            subtitle: 'global_support_contentservices_info_subtitle_4',
            list: [
                'global_support_contentservices_info_text_40',
                'global_support_contentservices_info_text_41',
                'global_support_contentservices_info_text_42',
            ],
        },
    ]);

    // const formatedDetailName = computed(
    //     () => (index: number) => t(detailItemList[index].title).split(' ').join('<br/>'),
    // );
    // addToVideoElmt('.content-services-media-video');
    const initPC = (): Array<ScrollTrigger> => {
        return [
            ...addLeftEnter(
                '.content-services-grid-container:nth-child(2n) > .content-services-info-cointainer, .content-services-grid-container:nth-child(2n+1) > .content-services-media-container',
            ),
            ...addRightEnter(
                '.content-services-grid-container:nth-child(2n+1) > .content-services-info-cointainer, .content-services-grid-container:nth-child(2n) > .content-services-media-container',
            ),
        ];
    };
    const initMobile = (): Array<ScrollTrigger> => {
        return [...addSlideInUp('.content-services-info-cointainer,.content-services-media-container')];
    };
    onMounted(() => {
        const ifMatched = matchMobile();
        if (!ifMatched) {
            initPC();
        } else {
            initMobile();
        }
        // store.$subscribe(() => {
        //     scrollTriggerList.forEach((scrollTriggerItem) => scrollTriggerItem.kill());
        //     debounce(init, 500);
        // });
    });
</script>

<style lang="less" scoped>
    .content-services-layout {
        width: 100%;
        color: #090909;
        overflow: hidden;
        font-family: 'HarmonyOS Sans SC';

        margin-bottom: 100px;
        padding: .convert(60px) [ @vw];
        background: #ffffff;
        border-radius: 40px;

        .content-services-grid-container {
            display: grid;
            grid-template-columns: 7fr 5fr;
            grid-template-rows: 1fr;
            grid-column-gap: .convert(60px) [ @vw];
            grid-row-gap: .convert(80px) [ @vw];
            grid-auto-flow: dense; //自动填充 先列后行

            &:nth-child(2n + 1) {
                grid-template-columns: 5fr 7fr;

                .content-services-info-cointainer {
                    grid-column: 2;
                }

                .content-services-media-container {
                    grid-column: 1; //grid-column-start:2 grid-column-end: 3; 从第2根列线到第3根列线，跨越一个可以省略后面的/3  2/3
                }
            }

            &:nth-child(n + 2) {
                //从第三个开始
                margin-top: .convert(80px) [ @vw];
            }

            .content-services-media-container {
                width: .convert(724px) [ @vw];
                height: .convert(407px) [ @vw];
                font-size: 64px;
                background: #d9d9d9;

                display: flex;
                justify-content: center;
                align-items: center;

                video {
                    width: 100%;
                }
                @media (max-width: @screen-mobile-width) {
                    width: .convert(305px) [ @vw-mobile];
                    height: .convert(172px) [ @vw-mobile];
                }
            }

            .content-services-info-cointainer {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .content-services-info-subtitle {
                    font-size: .convert(24px) [ @vw];
                    line-height: normal;
                    font-weight: 400;
                    text-transform: capitalize;
                    // @media (max-width: @screen-mobile-width) {
                    //     font-size: .convert(16px) [ @vw-mobile] !important;
                    //     line-height: 160%;
                    // }
                }

                .content-services-info-title {
                    font-size: .convert(80px) [ @vw];
                    font-weight: 400;
                    line-height: normal;
                    margin-top: .convert(12px) [ @vw];

                    // line-height: .convert(96px) [ @vw];

                    // @media (max-width: @screen-mobile-width) {
                    //     font-size: .convert(@font-size-title-xs) [ @vw-mobile] !important;
                    //     line-height: 100%;
                    //     line-height: normal;
                    // }
                }

                .content-services-info-des {
                    margin-top: .convert(12px) [ @vw];
                    display: flex;
                    flex-direction: column;
                    gap: .convert(20px) [ @vw];

                    &-item {
                        font-size: .convert(24px) [ @vw];
                        font-weight: 400;
                        line-height: normal;
                    }

                    // @media (max-width: @screen-mobile-width) {
                    //     font-size: .convert(12px) [ @vw-mobile] !important;
                    //     line-height: 100%;
                    //     margin-top: 5px;
                    // }
                    // & div::before {
                    //     content: '√';
                    //     margin-right: 15px;
                    //     color: #000;
                    //     font-family: Roboto;
                    //     font-size: 32px;
                    //     font-style: normal;
                    //     font-weight: 300;
                    //     line-height: normal;
                    // }
                }
            }
        }

        @media (max-width: @screen-mobile-width) {
            padding: .convert(30px) [ @vw-mobile] .convert(20px) [ @vw-mobile] !important;
            border-radius: 20px;

            .content-services-grid-container {
                display: flex;
                flex-direction: column;
                gap: .convert(15px) [ @vw-mobile];

                // margin-bottom: 100px;

                &:nth-child(n + 2) {
                    //从第三个开始
                    margin-top: 30px;
                }
                .content-services-info-cointainer {
                    font-family: Montserrat;
                    .content-services-info-subtitle {
                        font-family: Montserrat;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: normal;
                    }

                    .content-services-info-title {
                        font-family: HarmonyOS Sans SC;
                        font-size: 36px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                    }

                    .content-services-info-des {
                        margin-top: 11px;

                        &-item {
                            font-family: HarmonyOS Sans SC;
                            font-size: 12px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: normal;
                        }

                        // & div::before {
                        //     content: '√';
                        //     margin-right: 5px;
                        //     color: #090909;
                        //     font-family: Roboto;
                        //     font-size: 14px;
                        //     font-style: normal;
                        //     font-weight: 300;
                        //     line-height: normal;
                        // }
                    }
                }
            }
        }
    }

    :lang(en) {
        .content-services-layout {
            .content-services-grid-container {
                .content-services-info-cointainer {
                    .content-services-info-subtitle {
                    }

                    .content-services-info-title {
                        font-size: .convert(64px) [ @vw];
                    }

                    .content-services-info-des {
                        &-item {
                        }
                    }
                }
            }
            @media (max-width: @screen-mobile-width) {
                .content-services-grid-container {
                    .content-services-info-cointainer {
                        .content-services-info-subtitle {
                        }

                        .content-services-info-title {
                            font-size: 36px;
                        }

                        .content-services-info-des {
                            &-item {
                            }
                        }
                    }
                }
            }
        }
    }
</style>
